/** Public site light/dark tasarım tokenları — admin’de kullanılmaz */

/** Tüm border kenarlarında kullanılan renk katmanı (border ile birlikte kullanılır) */
const borderTone = "border-neutral-200/80 dark:border-white/10";

export const pub = {
  pageText: "text-neutral-900 dark:text-zinc-100",

  /** Kutular: `border` veya `border-b` ile birlikte kullanılır (çizgi rengi) */
  borderSubtle: borderTone,
  borderStrongTone: "border-neutral-300 dark:border-white/20",

  gridHairline: "gap-px bg-neutral-200/80 dark:bg-white/10",

  heroHeading: "text-neutral-950 dark:text-white",
  muted: "text-neutral-600 dark:text-zinc-400",
  mutedStr: "text-neutral-500 dark:text-zinc-400",

  /** Form etiketleri (Field label) — light/dark hizalı */
  labelMuted: "font-sans text-xs font-medium text-neutral-600 dark:text-zinc-400",
  /** İkonların ikincil (soluk) rengi */
  iconMuted: "text-neutral-500 dark:text-zinc-500",

  /** Genel yüz yüz kart */
  card:
    "border bg-white shadow-sm border-neutral-200/80 dark:border-white/10 dark:bg-white/[0.04] dark:shadow-none",
  /** Önemli kart */
  cardElevated:
    "border bg-white border-neutral-200/80 shadow-lg shadow-neutral-200/60 dark:bg-white/[0.06] dark:border-white/10 dark:shadow-xl dark:shadow-black/20",

  hoverText: "hover:text-neutral-900 dark:hover:text-white",

  linkMuted:
    "text-neutral-600 hover:text-neutral-900 dark:text-zinc-400 dark:hover:text-white transition-colors",

  /** Koyu modda düşük kontrast yerine düz zemin + zinc metin (şeffaf üst üste yazı kaybını önler) */
  input:
    "w-full bg-white text-neutral-900 border border-neutral-200 placeholder:text-neutral-400 dark:bg-zinc-950 dark:text-zinc-50 dark:caret-zinc-100 dark:border-white/15 dark:placeholder:text-zinc-500",
  inputFocus: "focus:outline-none focus:border-orange-400 focus:ring-2 focus:ring-orange-400/20",

  softPanel:
    "bg-neutral-50 border border-neutral-200/80 dark:border-white/10 dark:bg-white/[0.03]",

  dashedUpload:
    "border-2 border-dashed bg-white border-neutral-300 hover:border-orange-400 hover:bg-orange-50/40 dark:bg-white/[0.04] dark:border-white/10 dark:hover:border-orange-400/60 dark:hover:bg-orange-500/5",

  btnGhost:
    "border border-neutral-300 bg-white hover:bg-neutral-50 text-neutral-900 dark:border-white/20 dark:bg-transparent dark:hover:bg-white/5 dark:text-white",

  /** İç ara çizgi (koyu paneller içinde ModelViewer vb.) */
  panelInnerDivide: "border-neutral-700/50",
};
